import logo from "@/assets/logo-kc.png";

/**
 * Loader plein écran — léger et fluide.
 * - GPU-friendly (uniquement transform/opacity)
 * - Respecte prefers-reduced-motion (motion-reduce:*)
 */
export const RouteFallback = () => (
  <div
    role="status"
    aria-live="polite"
    aria-label="Chargement de la page"
    className="fixed inset-0 z-[100] flex h-screen min-h-screen w-screen items-center justify-center overflow-hidden bg-ink text-white"
  >
    {/* Halo radial statique */}
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_50%_40%_at_50%_50%,hsl(38_60%_55%/0.15),transparent_70%)]" />

    <div className="relative flex flex-col items-center gap-7">
      {/* Sceau central + anneaux orbitaux (désactivés en reduced motion) */}
      <div className="relative size-28 will-change-transform">
        <div className="absolute inset-0 rounded-full border border-accent/30 [mask-image:conic-gradient(from_0deg,transparent_0%,black_30%,transparent_60%)] motion-safe:animate-[spin_6s_linear_infinite]" />
        <div className="absolute inset-3 rounded-full border border-white/20 [mask-image:conic-gradient(from_0deg,transparent_0%,black_35%,transparent_65%)] motion-safe:animate-[spin_4s_linear_infinite_reverse]" />
        <div className="absolute inset-0 flex items-center justify-center">
          <img
            src={logo}
            alt=""
            className="h-9 w-auto brightness-0 invert motion-safe:animate-pulse"
            width={64}
            height={36}
            decoding="async"
          />
        </div>
      </div>

      <div className="flex flex-col items-center gap-2">
        <p className="font-display text-sm uppercase tracking-[0.4em] text-white/80">
          K&amp;C&nbsp;Services
        </p>
        <p className="text-[10px] uppercase tracking-[0.45em] text-white/40">Chargement</p>
      </div>

      {/* Barre indéterminée — désactivée si reduced motion (reste visible mais statique) */}
      <div className="relative h-px w-44 overflow-hidden bg-white/10">
        <span className="absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-transparent via-accent to-transparent motion-safe:animate-[loader-sweep_1.8s_ease-in-out_infinite]" />
      </div>
    </div>
  </div>
);
